import { useMatcherContext } from '../context';
import Button from '@ramsey-design-system/button';
import { MatcherVerificationStatus } from '../enums';
import { useMatcherButtonSize } from '../utils';

interface MatcherResubmitButtonProps {
  onClick: () => void;
  status: MatcherVerificationStatus;
}

function getMatcherResendButtonText(
  status: MatcherVerificationStatus,
  phoneVerificationCountDown: number
) {
  if (status === MatcherVerificationStatus.resendingCode) {
    return 'Resending Code . . .';
  } else if (phoneVerificationCountDown > 0) {
    return `Resend Code in ${phoneVerificationCountDown}`;
  } else {
    return 'Resend Code';
  }
}

export function MatcherResubmitButton({
  onClick,
  status
}: Readonly<MatcherResubmitButtonProps>) {
  const { phoneVerificationCountDown } = useMatcherContext();
  const resendButtonText = getMatcherResendButtonText(
    status,
    phoneVerificationCountDown
  );
  const buttonSize = useMatcherButtonSize();

  return (
    <Button
      data-testid="tax_matcher_resend_code_button"
      type="button"
      className="!w-full"
      iconPosition="right"
      appearance="subtle"
      fullWidthOnMobile={true}
      size={buttonSize}
      onClick={onClick}
      loading={status === MatcherVerificationStatus.resendingCode}
      disabled={
        phoneVerificationCountDown > 0 ||
        status === MatcherVerificationStatus.resendingCode ||
        status === MatcherVerificationStatus.verifyingCode ||
        status === MatcherVerificationStatus.redirecting
      }
    >
      {resendButtonText}
    </Button>
  );
}
